export default "__VITE_ASSET__B9TEJxa4__"